import moment from 'moment-timezone';
import { FORMAT_DATE } from '../../constants/common';
import { ScheduleTilesType } from '../../repository/mytm/schedule-tiles/scheduleTilesRepository';

export const toDataFormScheduleTiles = (record: ScheduleTilesType): any => {
  return {
    startDate: record?.activeAt ? moment(moment(record?.activeAt).format(FORMAT_DATE)) : null,
    startTime: record?.activeAt ? moment(record?.activeAt) : null,
    endDate: record?.inActiveAt ? moment(moment(record?.inActiveAt).format(FORMAT_DATE)) : null,
    endTime: record?.inActiveAt ? moment(record?.inActiveAt) : null,
  };
};
